// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TagsTwoToneSvg from "@fishx/icons-svg/es/asn/TagsTwoTone";
import FishxIcon from '../components/FishxIcon';

var TagsTwoTone = function TagsTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: TagsTwoToneSvg
  }));
};

TagsTwoTone.displayName = 'TagsTwoTone';
export default React.forwardRef(TagsTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/TagsTwoTone.js
// module id = 4239
// module chunks = 0